function appData() {
  const APP_DATA = typeof window !== 'undefined'
    ? window.__MA__
    // eslint-disable-next-line no-undef
    : context.__MA__;

  if (APP_DATA === undefined) {
    throw new Error('window.APP_DATA is not set');
  }
  return APP_DATA;
}

export function getInjectedJsonOrFail(key) {
  const APP_DATA = appData();

  if (APP_DATA[key] === undefined) {
    throw new Error(`window.APP_DATA[${key}] is undefined`);
  }

  return APP_DATA[key];
}

export function getInjectedJson(key) {
  const APP_DATA = appData();
  return APP_DATA[key];
}
